<template>
  <div class="print" style="display: block">
    <!-- mensaje -->
    <div class="mensaje">
      <p>Gracias por su preferencia!</p>
    </div>
    <!-- /mensaje -->

    <!-- main -->
    <div class="col-12 main pb-5">
      <!-- info negocio -->
      <div class="info-negocio mb-5">
        <div class="info-wrap mt-5">
          <img
            src="https://vossmueblerias.com.mx/img/logo.eb8b33b4.png"
            alt=""
            style="width: 100px"
          />
          <!--
          <p class="body-2 mt-5">
            <span class="caption font-weight-black">Dirección</span> <br />
            Dolores Rojas Beltran 420 el cercado Santiago NL 67300 <br />
            <span class="caption font-weight-black">Teléfono</span> <br />
            (81)22851977 celular y whats app celular 81. 119761041

            <br />

            <span class="caption font-weight-black">Página de internet </span>
            <br />
            www.vossmueblerias.com.mx <br />
            <span class="caption font-weight-black">Facebook </span> <br />
            One diamond , sandycavazossalon <br />
            <span class="caption font-weight-black">Instagram </span> <br />
            @onediamond.hair @sandycavazossalon
          </p>
          -->
        </div>

        <h1 class="display-2 font-weight-black">Venta #{{ id_venta }}</h1>
      </div>
      <!-- /info negocio -->

      <div class="mt-100 d-flex align-center justify-space-between">
        <h1 class="display-1 font-weight-black">Total: ${{ monto }}</h1>

        <div class="right">
          <v-chip v-if="estatus == 'parcial'" color="red" dark
            >Parcialmente pagado</v-chip
          >
          <v-chip v-else color="green" dark>Pagado</v-chip>

          <v-btn color="primary" class="ml-2 no-printable" @click="print()">
            <v-icon class="mr-3">print</v-icon>Imprimir
          </v-btn>

          <v-btn
            class="ml-2 no-printable"
            color="red"
            outlined
            dark
            @click="$router.go(-1)"
          >
            <v-icon left>close</v-icon>Cerrar
          </v-btn>
        </div>
      </div>

      <!-- cliente  -->
      <div class="mt-5">
        <div class="print-title">
          <h1 class="subtitle-1 font-weight-black mt-100">Datos del cliente</h1>
        </div>
        <v-simple-table>
          <thead>
            <tr>
              <th class="text-left">Cliente</th>
              <th class="text-left">Teléfono</th>
              <th class="text-left">Dirección</th>
              <th class="text-left">Email</th>
              <th class="text-left">Estatus</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ cliente }}</td>
              <td>{{ telefono }}</td>
              <td>{{ direccion }}</td>
              <td>{{ email }}</td>
              <td>{{ estatus }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
      <!-- /cliente -->

      <!-- productos  -->
      <div class="mt-5">
        <div class="print-title">
          <h1 class="subtitle-1 font-weight-black mt-100">
            Productos y Servicios
          </h1>
        </div>

        <v-simple-table>
          <thead>
            <tr>
              <th class="text-left">Imagen</th>
              <th class="text-left">Nombre</th>
              <th class="text-left">Precio</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item.id">
              <td>
                <img
                  v-if="item.imagen == ''"
                  style="padding: 10px"
                  width="50"
                  src="https://vossmueblerias.com.mx/img/logo.eb8b33b4.png"
                />
                <img
                  v-else
                  style="padding: 10px"
                  width="50"
                  :src="item.imagen"
                />
              </td>
              <td>{{ item.nombre }}</td>
              <td>${{ item.precio }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
      <!-- /productos -->

      <!-- pagos  -->
      <div class="mt-5">
        <div class="print-title">
          <h1 class="subtitle-1 font-weight-black mt-100">Pagos</h1>
        </div>
        <v-simple-table>
          <thead>
            <tr>
              <th class="text-left">Monto</th>
              <th class="text-left">Fecha</th>
              <th class="text-left">Concepto</th>
              <th class="text-left">Método de pago</th>
              <th class="text-left">Tipo de pago</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in pagos" :key="item.id">
              <td>${{ item.monto }}</td>
              <td>{{ item.fecha }}</td>
              <td>{{ item.concepto }}</td>
              <td>{{ item.metodo_pago }}</td>
              <td>{{ item.tipo_pago }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
      <!-- /pagos -->
    </div>
    <!-- /main -->
  </div>
</template>

<script>
import router from "@/router";
import { setTimeout } from "timers";
import myUpload from "vue-image-crop-upload";
const axios = require("axios");
export default {
  data() {
    return {
      fecha: "",
      cliente: "",
      telefono: "",
      monto: "",
      direccion: "",
      pago_final: "",
      email: "",
      loader: true,
      tipo_pago: "",
      abono: "",
      metodo_pago_restante: "Efectivo",
      estatus: "",
      metodos_pago: [
        { text: "Efectivo", value: "Efectivo" },
        { text: "Tarjeta de crédito", value: "Tarjeta de crédito" },
        { text: "Deposito Bancario", value: "Deposito Bancario" },
      ],

      suma_pagos_venta: "",
      cuenta: "",

      estatus_pago: "",
      abonos: "",
      total_venta: "",
      items: [],

      pagos: [],

      id_venta: this.$route.params.id,
    };
  },
  methods: {
    saberTotal() {
      this.cuenta = this.monto - this.suma_pagos_venta;
      console.log(this.monto);
      console.log(this.cuenta);

      if (this.cuenta < this.monto) {
        return true;
      } else {
        return false;
      }
    },
    getVentaData() {
      //Obtenemos los datos del producto
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getVentaData&id=" +
            this.id_venta
        )
        .then((response) => {
          this.fecha = response.data.fecha;
          this.cliente = response.data.cliente;
          this.telefono = response.data.telefono;
          this.monto = response.data.monto;
          this.direccion = response.data.direccion;
          this.email = response.data.email;
          this.tipo_pago = response.data.tipo_pago;
          this.abono = response.data.abono;
          this.estatus = response.data.estatus;
        })
        .catch((error) => console.log(error));
    },

    getVentaItems() {
      //Obtenemos los datos del producto
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getVentaItems&id=" +
            this.id_venta
        )
        .then((response) => {
          this.loader = false;
          this.items = response.data;
        })
        .catch((error) => console.log(error));
    },

    //Obtenemos los pagos de la venta
    getPagosVenta() {
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getPagosVenta&id=" +
            this.id_venta
        )
        .then((response) => {
          //Asignamos el valor
          this.pagos = response.data;
        })
        .catch((error) => console.log(error));
    },

    //Obtenemos el estatus del pago de la venta
    getEstatusPagoVenta() {
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getEstatusPagoVenta&id=" +
            this.id_venta
        )
        .then((response) => {
          this.estatus_pago = response.data.estatus;
          this.abonos = response.data.abonos;
          this.total_venta = response.data.total_venta;
        })
        .catch((error) => console.log(error));
    },
    agregarPagoFinal() {
      //Obtenemos los datos del producto
      this.pago_final = this.monto - this.abonos;

      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=agregarPagoFinal&id=" +
            this.id_venta +
            "&monto=" +
            this.pago_final +
            "&metodo_pago=" +
            this.metodo_pago_restante
        )
        .then((response) => {
          this.$swal({
            type: "success",
            customClass: "arriba",
            title: "El pago se agregó correctamente",
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch((error) => console.log(error));
      setTimeout(
        () =>
          router.push({
            name: "ventas_admin",
          }),
        1500
      );
    },

    print() {
      window.print();
    },

    showAlert() {
      // Use sweetalert2
      this.$swal({
        title: "Estás seguro que deseas eliminar la venta",
        text: "No podrás deshacer este cambio!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, estoy seguro!",
        cancelButtonText: "No!",
      }).then((result) => {
        if (result.value) {
          //Enviamos petición al servidor
          this.deleteVenta();
        }
      });
    },

    showAlertPago() {
      // Use sweetalert2
      this.$swal({
        title: "Estás seguro que deseas agregar el pago final?",
        text: "No podrás deshacer este cambio!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, estoy seguro!",
        cancelButtonText: "No!",
      }).then((result) => {
        if (result.value) {
          //Enviamos petición al servidor
          this.agregarPagoFinal();
        }
      });
    },
    deleteVenta() {
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=deleteVenta&id=" +
            this.id_venta
        )
        .then((response) => {
          this.$swal({
            type: "success",
            title: "La venta se borró exitosamente",
            showConfirmButton: false,
            timer: 1500,
          });

          setTimeout(
            () =>
              router.push({
                name: "ventas_admin",
              }),
            1500
          );
        })
        .catch((error) => console.log(error));
    },
  },

  mounted() {
    this.getPagosVenta();
    this.getVentaData();
    this.getVentaItems();
    this.getEstatusPagoVenta();
  },
};
</script>
